import React from "react";
import PropTypes from "prop-types";
import TextOptions from "./TextOptions";
import PollText from "./PollText";

function TextPoll(props) {
  const {
    isEdit,
    handleOptionsChange,
    handleRemoveOptions,
    options,
    disabled,
    editablePost,
  } = props;
  return (
    <>
      <PollText {...props} />
      <TextOptions
        handleOptionsChange={handleOptionsChange}
        handleRemoveOptions={handleRemoveOptions}
        isEdit={isEdit}
        options={options}
        disabled={disabled}
        editablePost={editablePost}
      />
    </>
  );
}

TextPoll.propTypes = {
  options: PropTypes.array,
  handleTitleChange: PropTypes.func,
  title: PropTypes.string,
  disabled: PropTypes.bool,
  handleOptionsChange: PropTypes.func,
  handleRemoveOptions: PropTypes.func,
  isEdit: PropTypes.bool,
  token: PropTypes.string,
  preview: PropTypes.object,
};

export default TextPoll;
